module.exports = __webpack_public_path__ + "static/img/collaborator.6ea084eb.png";